export default "<i class=\"dbi {{icon}}\"></i>\r\n";